import utils from 'utils'
class statisticsReportCtrl {
    constructor($scope, httpRequest, $state, $stateParams, sweetalert, logger, SRFieldConfig, $timeout, authService, $filter, Upload, $uibModal) {
        $scope.importBtnCollapsed = false
        $scope.ifFlodBillTypeBox = true // 票据类型选择框初始为折叠状态
        // 查询的参数
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                applyPeriod: utils.getLastMonthFirstLast().preMonth,
                cityName: '',
                departmentNo: '',
                province: '',
                regionName: '',
                saleCreditCode: '',
                saleName: '',
                summaryStatisticsType: '',
            },
        }
        // 重置
        $scope.reset = function () {
            $scope.belleRegionCityList = []
            $scope.queryParam.param = {
                applyPeriod: utils.getLastMonthFirstLast().preMonth,
                cityName: '',
                departmentNo: '',
                province: '',
                regionName: '',
                saleCreditCode: '',
                saleName: '',
                summaryStatisticsType: $scope.dimensionIndex,
            }
        }
        // 勾选的信息
        $scope.selectedRows = []
        //自动查询展示
        const queryInfo = function queryInfo() {
            const openLoading =
                $scope.queryParam.pageSize >= 100
                    ? window.layer.msg('正在查询，请耐心等待', {
                          time: 0,
                          skin: 'layer-loading-self',
                          icon: 16,
                          shade: 0.5,
                      })
                    : null
            httpRequest
                .post_selectSummaryStatisticsList($scope.queryParam)
                .then((res) => {
                    $scope.listData = res.data.value.list
                    $scope.totalItems = res.data.value.total
                    $scope.queryParam.pageNum = res.data.value.pageNum
                    $scope.queryParam.pageSize = res.data.value.pageSize
                    $scope.selectedRows = []
                })
                .finally(() => {
                    window.layer.close(openLoading)
                })
        }
        // 搜索
        $scope.searchList = function () {
            queryInfo()
        }
        // 分页
        $scope.pageChanged = function () {
            // 点击页码发起查询
            queryInfo()
        }
        // 改变税款所属月份
        $scope.updateSearch = function () {
            queryInfo()
        }
        // 字典
        const typecodeArrStr = [
            'zzs_data', // 数据来源
            'department_no',
            'glsale_declaration', //申报状态
            'taxplayer_type',
        ]
        $scope.dictionary = {}
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = $.extend($scope.dictionary, res.data.value)
        })
        // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
        httpRequest.get_getBelleRegion().then((res) => {
            $scope.belleRegionList = res.data.value
        })
        // 联动查询管理城市
        $scope.linkageQuery = function (enumName) {
            console.log(enumName)
            let departmenNoObj = $scope.dictData.department_no.find((v) => {
                return v.enumName === enumName
            })
            let belleRegionListObj = $scope.belleRegionList.find((v) => {
                return v.regionName === enumName
            })
            if (departmenNoObj) {
                $scope.departmentNo = departmenNoObj.enumCode
            }
            if (belleRegionListObj) {
                $scope.regionNo = belleRegionListObj.treeLevelCode
            }
            let params = {
                affiliation: $scope.departmentNo,
                regionNo: $scope.regionNo,
            }
            if (params.affiliation == '' || params.regionNo == '') return
            httpRequest.get_getBelleRegion(params).then((res) => {
                $scope.belleRegionCityList = res.data.value
            })
        }
        // 获取所有主管税局信息
        httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
            $scope.dictDataProvince = res.data.value
        })
        //导出
        $scope.exportExel = function exportExel() {
            const exportParam = $.extend({}, $scope.queryParam.param)
            const url = `${host.etcloudIvatApp}taxdeclaration/rpaSummaryStatistics/exportSummaryStatisticsExcel?accessToken=${localStorage.getItem('id_token')}`
            utils.post_downLoad(exportParam, url)
        }
        // 票据类型框中票据
        $scope.statisticalDimensionConfig = [
            {
                type: 0,
                label: '事业部',
            },
            {
                type: 1,
                label: '所属区域',
            },
            {
                type: 2,
                label: '管理城市',
            },
            {
                type: 3,
                label: '主管税局',
            },
            {
                type: 4,
                label: '机构税号',
            },
        ]
        /**
         * @description:不同维度的配置字段及查询
         * @param {*} type 对应维度index
         * @return {*}
         */
        $scope.statisticalDimension = (type) => {
            $scope.dimensionIndex = type
            $scope.reset()
            $scope.queryParam.param.summaryStatisticsType = type
            $scope.customizedConfig = SRFieldConfig[type]
            $scope.profileType = $scope.customizedConfig.profileType
            queryInfo()
        }
        $scope.statisticalDimension(0)
        /**
         * @description: 监听customizedConfig更新用户操作习惯配置
         * @param {*}
         * @return {*}
         */
        $scope.$watch('customizedConfig', (newValue, oldValue) => {
            $scope.fieldChange(newValue)
        })
        /**
         * @description: 设置列表字段显示隐藏
         * @param {*} fieldConfig 返回的字段配置 根据table控制
         * @return {*}
         */
        $scope.fieldChange = (fieldConfig) => {
            const { colspanList, profileType } = fieldConfig
            if (!colspanList.length) return
            let newColspanList = []
            let newTableItem = []
            if ($scope.profileType == profileType) {
                fieldConfig.table.forEach((el) => {
                    if (el.fatherId) {
                        fieldConfig.colspanList.forEach((item) => {
                            if (el.fatherId == item.childId) {
                                const { selected, ...restProps } = item
                                newColspanList.push({ ...restProps, selected: el.selected })
                            }
                        })
                        fieldConfig.tableItem.forEach((item) => {
                            if (el.fatherId == item.childId) {
                                const { selected, ...restProps } = item
                                newTableItem.push({ ...restProps, selected: el.selected })
                            }
                        })
                    }
                })
                fieldConfig.colspanList = newColspanList
                fieldConfig.tableItem = newTableItem
                $scope.customizedConfig = fieldConfig
            }
        }
    }
}
statisticsReportCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', 'sweetalert', 'logger', 'SRFieldConfig', '$timeout', 'authService', '$filter', 'Upload', '$uibModal']
export default statisticsReportCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/declareASummary/statisticsReport/statisticsReportCtrl.js